const emailRegExp = /^([^:;,[\]\\<>()\s@]+)@([^\s@]+\.)+([a-zA-Z]{2,})$/

export const emailValidator = (emailFieldValue?: string) => {
  if (!emailFieldValue) return false

  const splitEmails = emailFieldValue.split(';').map((email) => email.trim())

  for (const emailToValidate of splitEmails) {
    if (!emailRegExp.test(emailToValidate)) return false
  }

  return true
}
